import {
  CompactPlan,
  SinglePlan,
  Mtds,
  PlanStatusTag,
  toLocaleDateString,
  CalendarBlankIcon,
  PencilSimpleIcon,
  TrashIcon
} from 'prove-common'
import { PlanStatusMenuItems } from '../plan-status-menu-items/PlanStatusMenuItems'
import { getPlanIconId, getPlanIconOption } from '../../plan-icons/planIcons'
import { useIsWorkspaceFeatureEnabled } from '../../workspaces/workspaces'

type PlanCardContentProps = {
  plan: SinglePlan | CompactPlan
  onClickEdit?: () => void
  onClickMove?: () => void
  onClickDuplicate?: () => void
  onClickActivate?: () => void
  onClickDeactivate?: () => void
  onClickSetAsDraft?: () => void
  onClickDelete?: () => void
}

export const PlanCardContent = ({
  plan,
  onClickEdit,
  onClickMove,
  onClickDuplicate,
  onClickActivate,
  onClickDeactivate,
  onClickSetAsDraft,
  onClickDelete
}: PlanCardContentProps) => {
  const isWorkspaceFeatureEnabled = useIsWorkspaceFeatureEnabled().enabled
  const menuId = `plan-menu-${plan.id}`
  const PlanIcon = getPlanIconOption(getPlanIconId(plan.id)).icon

  const hasMenuActions =
    !!onClickEdit ||
    !!onClickMove ||
    !!onClickDuplicate ||
    !!onClickActivate ||
    !!onClickDeactivate ||
    !!onClickSetAsDraft ||
    !!onClickDelete

  return (
    <Mtds.Grid
      data-gap='4'
      className='grid-cols-[auto_minmax(0,1fr)] items-center lg:grid-cols-[auto_minmax(0,1fr)_auto]'
    >
      {isWorkspaceFeatureEnabled && (
        <span className='grid shrink-0 place-items-center text-2xl'>
          <PlanIcon aria-hidden />
        </span>
      )}
      <Mtds.Heading as='h3' data-size='xs' className='min-w-0'>
        {plan.description}
      </Mtds.Heading>
      <Mtds.Flex
        data-align='center'
        data-gap='4'
        data-justify='end'
        className='col-span-2 lg:col-span-1'
      >
        <PlanStatusTag status={plan.status} />
        <Mtds.Flex data-align='center' data-gap='1' data-nowrap>
          <CalendarBlankIcon aria-hidden />
          <span>{toLocaleDateString(plan.due) ?? 'Ingen frist'}</span>
        </Mtds.Flex>
        {hasMenuActions && (
          <div>
            <Mtds.Button
              aria-label='Handlingsmeny'
              popoverTarget={menuId}
              onClick={(event) => {
                event.stopPropagation()
              }}
            />
            <Mtds.Popover as='menu' id={menuId}>
              {onClickEdit && (
                <li>
                  <Mtds.Button
                    type='button'
                    onClick={(event) => {
                      event.stopPropagation()
                      onClickEdit()
                    }}
                  >
                    <PencilSimpleIcon />
                    Rediger
                  </Mtds.Button>
                </li>
              )}
              <PlanStatusMenuItems
                status={plan.status}
                onClickMove={onClickMove}
                onClickDuplicate={onClickDuplicate}
                onClickActivate={onClickActivate}
                onClickDeactivate={onClickDeactivate}
                onClickSetAsDraft={onClickSetAsDraft}
              />
              {onClickDelete && (
                <li>
                  <Mtds.Button
                    type='button'
                    data-color='danger'
                    onClick={(event) => {
                      event.stopPropagation()
                      onClickDelete()
                    }}
                  >
                    <TrashIcon />
                    Slett
                  </Mtds.Button>
                </li>
              )}
            </Mtds.Popover>
          </div>
        )}
      </Mtds.Flex>
    </Mtds.Grid>
  )
}
